import React from "react";
import { h, Component } from "preact";
import classNames from "classnames";
import { Scrollbars } from "preact-custom-scrollbars";
import WindowHeader from "./WindowHeader";
import WindowFooter from "./WindowFooter";
import MenuItem from "./MenuItem";
import FileItem from "./FileItem";
import StartBtn from "./StartBtn";
import MessagesList from "./MessagesList";
import UnreadMessagesBadge from "./UnreadMessagesBadge";
import AudioMessageField from "./audio/AudioMessageField";
import {FaRegWindowClose} from "react-icons/fa";

export default class Widget extends Component {
    state = {
        showMenu: false,
        input: "",
        file: null,
        startSent: false,
    };

    constructor() {
        super(...arguments);

        this.collectAndSendMessage = this.collectAndSendMessage.bind(this);
        this.deleteFile = this.deleteFile.bind(this);
        this.deleteAudio = this.deleteAudio.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.handleAudioChanged = this.handleAudioChanged.bind(this);

        this.messageInputRef = null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.textTypeEnabled && this.props.textTypeEnabled && this.messageInputRef) {
            this.messageInputRef.focus();
        }
    }

    collectAndSendMessage() {
        let message = this.state.input;
        let file = this.state.file;
        let audio = this.state.audio;

        if (message || file || audio) {
            this.setState({ input: "", file: null, audio: null });
            if (this.props.channel) {
                this.props.channel.whisper("typing", {
                    message: "",
                });
            }

            this.props.sendMessage(message, file, null, null, null, audio);
        }
    }

    deleteFile() {
        this.setState({ file: null });
    }

    deleteAudio() {
        this.setState({ audio: null });
    }

    toggleMenu() {
        this.setState(({ showMenu }) => ({ showMenu: !showMenu }));
    }

    handleAudioChanged(blob) {
        this.setState({ audio: blob })
    }

    componentDidMount(nextProps, nextState, nextContext) {
        if (this.props.messages.length === 0 && this.props.autostart_on_chat_page && !this.state.startSent) {
           setTimeout(() => {
               this.props.sendMessage('start');
           }, 300)
        }
    }

    render() {
        const {
            isFullScreen,
            rtl,
            messages,
            sendMessage,
            start_btn,
            newMessages,
            textTypeEnabled,
            placeholder,
            menus,
            channel,
            badge,
            scrollBottom
        } = this.props;
        const hasMassages = messages.length > 0;

        return (
            <div
                className={classNames("window-wrapper mx-auto my-4", {
                    fullscreen: isFullScreen,
                    rtl,
                })}>
                <WindowHeader {...this.props} />
                <div className="window-body">
                    <div className={"relative"}>
                        <Scrollbars
                            className={classNames("messages-list", {
                                "has-files": this.state.file,
                                "has-audio": this.state.audio,
                            })}
                            ref={(el) => (this.list = el)}
                            renderThumbVertical={(props) => (
                                <div
                                    {...props}
                                    className="scroll-thumb-vertical"
                                />
                            )}
                            renderTrackVertical={(props) => (
                                <div
                                    {...props}
                                    className="scroll-track-vertical"
                                />
                            )}
                            renderView={(props) => (
                                <div {...props} className="scroll-view" />
                            )}>
                            {hasMassages ? (
                                <MessagesList
                                    cardWidth={this.props.cardWidth}
                                    messages={messages}
                                    sendMessage={sendMessage}
                                    getMessageImage={this.props.getMessageImage}
                                />
                            ) : (
                                <StartBtn
                                    start_btn={start_btn}
                                    sendMessage={sendMessage}
                                />
                            )}
                        </Scrollbars>
                        {!!newMessages && (
                            <UnreadMessagesBadge
                                newMessagesCount={newMessages}
                                onClick={scrollBottom}
                            />
                        )}
                    </div>
                    {this.state.file && (
                        <FileItem
                            file={this.state.file}
                            deleteFile={this.deleteFile}
                        />
                    )}
                    {this.state.audio && (
                        <div className="audio-message-wrapper">
                            <div className="audio-message">
                                <button type="button" className="audio-btn audio-close-btn" onClick={this.deleteAudio}>
                                    <FaRegWindowClose
                                        className={"icon-size-20 color-close"}
                                    />
                                </button>
                                <div style={{ maxWidth: "400px" }} className="audio-block">
                                    <audio src={URL.createObjectURL(this.state.audio)} controls={true}></audio>
                                </div>
                            </div>
                        </div>
                    )}
                    {this.state.showMenu && (
                        <div className={"context-menu"}>
                            <ul>
                                {menus.map((item, i) => (
                                    <MenuItem
                                        key={i}
                                        item={item}
                                        onClick={() =>
                                            this.setState({ showMenu: false })
                                        }
                                        sendMessage={sendMessage}
                                    />
                                ))}
                            </ul>
                        </div>
                    )}
                    {hasMassages && (
                        <div
                            className={classNames(
                                "type-message",
                                "has-load-btn",
                                {
                                    disabled: !textTypeEnabled,
                                },
                            )}>
                            <button
                                type="button"
                                className={"menu-btn"}
                                onClick={this.toggleMenu}>
                                <i className={"icon-menu"} />
                                <span className={"badge"}>{badge}</span>
                            </button>
                            <textarea
                                ref={(el) => (this.messageInputRef = el)}
                                disabled={!textTypeEnabled}
                                value={this.state.input}
                                onChange={() => {}}
                                onInput={(e) => {
                                    if (this.enter) return;
                                    const input = e.target.value;
                                    if (channel) {
                                        channel.whisper("typing", {
                                            message: input,
                                        });
                                    }

                                    this.setState({ input });
                                }}
                                placeholder={placeholder}
                                onKeyDown={(e) => {
                                    this.enter = false;
                                    if (e.keyCode === 13 && !e.shiftKey) {
                                        this.enter = true;
                                        e.stopPropagation();
                                        this.collectAndSendMessage();
                                    }
                                }}
                            />
                            <div className={"audio-btns-block"}>
                                <AudioMessageField
                                    disabled={!textTypeEnabled}
                                    onRecorded={this.handleAudioChanged}
                                />
                            </div>
                            <div className={"load-btn"}>
                                <label htmlFor="file">
                                    <i className={"icon-paperclip-solid icon-size-20 color-gray"} />
                                </label>
                                <input
                                    disabled={!textTypeEnabled}
                                    hidden
                                    onChange={(e) => {
                                        this.setState({
                                            file: e.target.files[0],
                                        });
                                    }}
                                    name="file"
                                    id="file"
                                    type="file"
                                />
                            </div>
                            <button
                                disabled={!textTypeEnabled}
                                className={"send-btn"}
                                onClick={this.collectAndSendMessage}>
                                <i className={"icon-telegram-plane"} />
                            </button>
                        </div>
                    )}
                </div>
                <WindowFooter {...this.props} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/widget/Widget.js